import { StudentSkillStates } from '../models/StudentSkillState';
import { StudentTour } from '../models/StudentTour';
import { TargetGroup } from '../models/TargetGroup';
import { TargetSkillTypeLabel } from '../models/TargetSkillType';
import { Unit } from '../models/Unit';

export const updateSSSWithIcons = (
  elements: StudentSkillStates[],
  tourMode: StudentTour,
  targetGroupRedux: TargetGroup,
  unitRedux: Unit | null,
  notInTargetGroups?: boolean,
) => {
  const sSSWithIcons: Array<StudentSkillStates> = [];

  if (tourMode === StudentTour.UNITS && unitRedux?.id) {
    elements.forEach(element => {
      element.skill.targetSkills?.forEach(el => {
        if (el.target.id === unitRedux?.id) {
          if (el.target.targetGroup?.id === targetGroupRedux.id)
            sSSWithIcons.push({
              ...element,
              targetSkillType:
                el.targetSkillType.name === TargetSkillTypeLabel.TARGET ? 'Unit' : el.targetSkillType.name,
            });
        }
      });
    });
  }

  if (tourMode === StudentTour.ALL_SKILLS) {
    elements.forEach(element => {
      const icon: string[] = [];
      let shouldIncludeSkill = false;

      element.skill.targetSkills?.forEach(el => {
        // If a unit is selected, only include skills that belong to that unit
        if (unitRedux?.id) {
          if (el.target.id === unitRedux.id && el.target.targetGroup?.id === targetGroupRedux.id) {
            icon.push(el.targetSkillType?.name);
            shouldIncludeSkill = true;
          }
        } else {
          // If no unit is selected, show all skills for the target group (original behavior)
          if (el.target.targetGroup?.id === targetGroupRedux.id) {
            icon.push(el.targetSkillType?.name);
            shouldIncludeSkill = true;
          } else {
            if (notInTargetGroups) {
              icon.push(TargetSkillTypeLabel.NOT_ON_A_ROADMAP);
              shouldIncludeSkill = true;
            }
          }
        }
      });

      // Only add skills that match our filtering criteria
      if (shouldIncludeSkill) {
        if (icon.includes(TargetSkillTypeLabel.TARGET)) {
          // In ALL_SKILLS mode with a unit selected, use 'Unit' instead of 'Target' to match UNITS mode behavior
          const targetSkillType = unitRedux?.id ? TargetSkillTypeLabel.UNIT : TargetSkillTypeLabel.TARGET;
          sSSWithIcons.push({ ...element, targetSkillType });
        } else if (icon.includes(TargetSkillTypeLabel.SUPPORT)) {
          sSSWithIcons.push({ ...element, targetSkillType: TargetSkillTypeLabel.SUPPORT });
        } else if (icon.includes(TargetSkillTypeLabel.NOT_ON_A_ROADMAP)) {
          sSSWithIcons.push({ ...element, targetSkillType: TargetSkillTypeLabel.NOT_ON_A_ROADMAP });
        }
      }
    });
  }

  return sSSWithIcons;
};
